import { useEffect, useState } from 'react'
import { AppIcon  } from '@/shared/ui/icons'

import _ from 'lodash'
import { DateTime } from 'luxon'
import { useTranslation } from '@/shared/hooks/useTranslation'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useFieldArray, useFormContext } from 'react-hook-form'
import toastr from 'toastr'

import { useResourceRecordContext } from '@/shared/hooks'
import { Button } from '@/shared/ui'
import { DateInput, ErrorMessage, FormControl, FormGroup, ImageInput, InputGroup, NestedFields, ReferenceFields, Select } from '@/shared/ui/Form'

import { validationSchema } from './validationSchema'

export const DigitalProductMyProfilePassword = () => {
  const { t } = useTranslation()
  const [showCurrentPassword, setShowCurrentPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordConfirmation, setShowPasswordConfirmation] =
    useState(false)

  return (
    <div>
      <FormGroup label="Senha atual" className="relative" vertical required>
        <InputGroup>
          <FormControl
            name="current_password"
            type={showCurrentPassword ? 'text' : 'password'}
            required
            solid
          />
          <Button
            type="button"
            variant="light"
            icon
            size="lg"
            leadingIcon={
              <AppIcon name={showCurrentPassword ? 'eye' : 'eye-slash'} />
            }
            className="shrink-0 rounded-none border-0"
            onClick={() => setShowCurrentPassword(prevState => !prevState)}
            aria-label={showCurrentPassword ? 'Ocultar senha' : 'Mostrar senha'}
          />
        </InputGroup>
        <ErrorMessage name="current_password" />
      </FormGroup>

      <FormGroup label="Nova senha" className="relative" vertical required>
        <InputGroup>
          <FormControl
            name="password"
            type={showPassword ? 'text' : 'password'}
            solid
            required
          />
          <Button
            type="button"
            variant="light"
            icon
            size="lg"
            leadingIcon={<AppIcon name={showPassword ? 'eye' : 'eye-slash'} />}
            className="shrink-0 rounded-none border-0"
            onClick={() => setShowPassword(prevState => !prevState)}
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          />
        </InputGroup>
        <ErrorMessage name="password" />
      </FormGroup>

      <FormGroup
        label="Confirmação de nova senha"
        className="relative"
        vertical
        required
      >
        <InputGroup>
          <FormControl
            name="password_confirmation"
            type={showPasswordConfirmation ? 'text' : 'password'}
            solid
            required
          />
          <Button
            type="button"
            variant="light"
            icon
            size="lg"
            leadingIcon={
              <AppIcon
                name={showPasswordConfirmation ? 'eye' : 'eye-slash'}
              />
            }
            className="shrink-0 rounded-none border-0"
            onClick={() => setShowPasswordConfirmation(prevState => !prevState)}
            aria-label={
              showPasswordConfirmation ? 'Ocultar senha' : 'Mostrar senha'
            }
          />
        </InputGroup>
        <ErrorMessage name="password_confirmation" />
      </FormGroup>
    </div>
  )
}

DigitalProductMyProfilePassword.validationSchema = validationSchema

